import React from 'react'

export default function Input({ value, setValue, id, type, label, placeholder, fillWidth, multiline }) {
    return (
        <div className={`form-group ${fillWidth ? 'col-md-12' : 'col-md-6'} mb-4`}>
            <label htmlFor={id}>{label}:</label>
            {
                multiline ?
                    <textarea 
                        id={id}
                        required
                        value={value}
                        rows={multiline}
                        style={{ minHeight: 200 }}
                        type={type || "text"} 
                        className="form-control"
                        placeholder={placeholder || ""} 
                        onChange={e=>setValue(e.target.value)}
                    />
                :    
                    <input 
                        id={id}
                        required
                        value={value}
                        autoComplete="off"
                        type={type || "text"} 
                        className="form-control"
                        placeholder={placeholder || ""} 
                        onChange={e=>setValue(e.target.value)}
                    />
            }
        </div>
    )
}
